import styled from 'styled-components'

import { CustomIconStyle } from './types'

const CustomIcon = styled.img<CustomIconStyle>`
  width: ${(p: CustomIconStyle) => p.size};
`

export { CustomIcon }
